<template>
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false &&
        checkaccessdata.is_checker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card elevation="0" v-else>
      <v-row class="mt-1">
        <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
          <v-data-table
            dense
            :headers="empheaders"
            :items="empitems"
            class="mt-5"
            :options.sync="pagination"
            :items-per-page="itemsPerPage"
            @update:options="card_getuserPagination()"
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{ empitems.indexOf(item) + 1 }}</span>
            </template>

            <template v-slot:top class="mb-n16">
              <v-card
                :width="isMobile ? '300' : 'auto'"
                elevation="1"
                class="mb-5 ml-2 mr-2"
                rounded="xl"
              >
                <v-row class="ml-1 mr-1">
                  <v-col cols="12" lg="6" xl="6" md="6" sm="12" xs="12">
                    <v-card-title class="ml-n2">
                      <span class="primary--text Heading 6"
                        >Department Budget
                      </span>
                    </v-card-title>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <v-select
                      label="Select Department"
                      class="mt-n1"
                      v-model="deptsss"
                      item-text="department_name"
                      item-value="department_id"
                      :items="depts"
                      @input="getbudget"
                      return-object
                      dense
                      outlined
                      :no-data-text="Nodata"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <v-text-field
                      v-model="search"
                      shaped
                      outlined
                      dense
                      class="mt-n1 mr-2"
                      color="primary"
                      append-icon="mdi-magnify"
                      label="Search"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span class="ml-3 green--text Heading 6">
                      <b class="primary--text">Selected Duration :</b>
                      Monthly
                    </span>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span
                      class="ml-3 green--text Heading 6"
                      v-if="deptsss.length != 0"
                    >
                      <b class="primary--text">Department Budget :</b>
                      {{ deptsss.total_budget }}
                    </span>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span
                      class="ml-3 green--text Heading 6"
                      v-if="deptsss.length != 0"
                    >
                      <b class="primary--text">Allocated Budget :</b>
                      {{ deptsss.allocated_budget }}
                    </span>
                  </v-col>
                  <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                    <span
                      class="ml-3 green--text Heading 6"
                      v-if="deptsss.length != 0"
                    >
                      <b class="primary--text">Unallocated Budget :</b>
                      {{ deptsss.unallocated_budget }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </template>
            <template v-slot:[`item.Actions`]="{ item }">
              <v-icon
                v-if="item"
                small
                @click="assignbudgettoemp(item)"
                color="primary"
                >mdi-plus</v-icon
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="assigndialog" width="500px">
      <v-card class="overflow-hidden" flat>
        <v-toolbar dark dense class="header">
          <v-icon>mdi-currency-btc</v-icon>
          <span class="ml-3">Assign budget </span>
          <v-spacer></v-spacer>

          <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row v-if="assigndialog" class="ml-2 mt-4">
          <v-card flat>
            <v-card-text>
              <v-row class="mt-n3">
                <span class="subtitle-2">
                  <b class="primary--text">Card User Name :</b>
                  {{ user_deatils.first_name }}
                </span>
              </v-row>
              <br />

              <v-row class="mt-1">
                <span class="subtitle-2">
                  <b class="primary--text">Department Name :</b>
                  {{ user_deatils.department_name }}
                </span>
              </v-row>
              <br />
              <v-row class="mt-1">
                <span class="subtitle-2">
                  <b class="primary--text">Department Budget :</b>
                  {{ user_deatils.dept_details.department_budget }}(MYR)
                </span>
              </v-row>
              <br />
              <v-row class="mt-1">
                <span class="subtitle-2">
                  <b class="primary--text">Allocated Budget :</b>
                  {{ user_deatils.dept_details.allocated_budget }}(MYR)
                </span>
              </v-row>
              <br />
              <v-row class="mt-1">
                <span class="subtitle-2">
                  <b class="primary--text">Unallocated Budget :</b>
                  {{ user_deatils.dept_details.unallocated_budget }}(MYR)
                </span>
              </v-row>
            </v-card-text>
          </v-card>
        </v-row>
        <v-row class="pa-3 mt-n2 mb-n7">
          <v-col cols="12" md="12">
            <v-text-field
              label="Assign Budget to Card User"
              v-model="Budget"
              dense
              outlined
              :hint="max_amount"
              persistent-hint
              :color="redcolor"
              @keypress="isNumber(event)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="assignbudgetouser" rounded
            >Assign</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  data: () => ({
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    checkaccessdata: {},

    assigndialog: false,
    user_deatils: "",
    Budget: "",
    department_id: "0",
    empheaders: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "FIRST NAME",
        value: "first_name",
      },
      {
        text: "MIDDLE NAME",
        value: "middle_name",
      },
      {
        text: "LAST NAME",
        value: "last_name",
      },

      {
        text: "CONTACT NUMBER",
        value: "mobile_no",
      },
      {
        text: "USER BUDGET",
        value: "user_budget",
      },
      {
        text: "DEPARTMENT NAME",
        value: "department_name",
      },
      {
        text: "ACTIONS",
        value: "Actions",
      },
    ],
    empitems: [],
    budget_id: "",
    deptsss: "",
    max_amount: "",
    redcolor: "",
    depts: [],
    deptbudget: "",
    search: "",
    Nodata: "",
  }),
  created() {
    this.checkaccess();
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },

  watch: {
    Budget(val) {
      if (Number(val) > Number(this.deptbudget)) {
        this.max_amount = `Enter Amount less than ${this.deptbudget}`;
        this.redcolor = "red";
        this.error = true;
      } else {
        this.max_amount = ``;
        this.redcolor = "";
        this.error = false;
      }
    },
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "BUDGET",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getdepartment();
        this.card_getuser();
      }
    },
    async getdepartment() {
      this.overlay = true;
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GDMASTER",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.depts = responseData.data.data;
        }
        // this.overlay = false;
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.depts = [];
      }
      // console.log("depdata", responseData);
    },
    async assignbudgetouser() {
      if (Number(this.Budget) <= Number(this.deptbudget)) {
        var inputData = {
          method_name: "BUDGET",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CUSRBUDGET",
            total_budget: this.Budget,
            user_id: this.user_deatils.user_id,
            dep_budget_id: this.budget_id,
          },
        };
        var responseData = await apiCall(inputData);
        //console.log("assignbudgetouser", responseData);
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: "Created successfully",
            color: "green",
          });
          this.card_getuser();
          this.assigndialog = false;
        } else {
          this.assigndialog = false;
          this.$store.commit("snackbar/showMessage", {
            content: "Failed to assign",
            color: "red",
          });
        }
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Enter Budget lesser than Department budget",
          color: "red",
        });
      }
    },
    async card_getuserPagination() {
      if (this.empitems.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "BUDGET",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GUSRBUDGET",
            search_text: "",
            corp_id: this.$store.getters.get_corpid,
            department_id: this.department_id,
          },
        };

        var responseData = await apiCall(inputData);

        this.empitems = this.empitems.concat(responseData.data.data);
      }
    },
    async card_getuser() {
      var inputData = {
        method_name: "BUDGET",
        page_no: null,
        record_count: 0,
        page_size: null,
        app_code: "CPORTAL",
        method_param: {
          action: "GUSRBUDGET",
          search_text: "",
          corp_id: this.$store.getters.get_corpid,
          department_id: this.department_id,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("getuser", responseData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.empitems = responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else {
        this.empitems = [];
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getbudget() {
      // console.log(this.deptsss);
      this.department_id = this.deptsss.department_id;
      this.card_getuser();
    },
    assignbudgettoemp(item) {
      // console.log(item);
      this.deptbudget = item.dept_details.department_budget;
      //  console.log("deptbudget",this.deptbudget);

      this.assigndialog = true;
      this.Budget = "";
      var self = this;
      self.depts.forEach(function (ele) {
        if (ele.department_name == item.department_name) {
          self.budget_id = ele.dep_budget_id;
        }
      });
      self.user_deatils = item;
    },
  },
};
</script>
